import { render, staticRenderFns } from "./PortCallsStat.vue?vue&type=template&id=7ef038d0&scoped=true&"
import script from "./PortCallsStat.vue?vue&type=script&lang=js&"
export * from "./PortCallsStat.vue?vue&type=script&lang=js&"
import style0 from "./PortCallsStat.vue?vue&type=style&index=0&id=7ef038d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef038d0",
  null
  
)

export default component.exports